/**
 * Dimensional search form validation
 * Ensures Inside Diameter (ID) is smaller than Outside Diameter (OD)
 * on both inline and sticky product search forms.
 */
(function () {
  var ERROR_MESSAGE = 'ID must be smaller than OD.';
  var ERROR_CLASS = 'dimensional-search-id-od-error';
  var INPUT_ERROR_CLASS = 'search-input--error';

  function parseDim(value) {
    if (value == null || String(value).trim() === '') return null;
    var parsed = parseFloat(String(value).trim());
    return Number.isNaN(parsed) ? null : parsed;
  }

  function getErrorEl(form) {
    return form.querySelector('.' + ERROR_CLASS);
  }

  function ensureErrorEl(form) {
    var err = getErrorEl(form);
    if (err) return err;

    err = document.createElement('div');
    err.className = ERROR_CLASS;
    err.setAttribute('role', 'alert');
    err.hidden = true;

    var grid = form.querySelector('.search-inputs-grid');
    if (grid && grid.parentNode) {
      grid.parentNode.insertBefore(err, grid.nextSibling);
    } else {
      form.appendChild(err);
    }
    return err;
  }

  function clearIdOdError(form) {
    var err = getErrorEl(form);
    if (err) {
      err.hidden = true;
      err.textContent = '';
    }

    form.querySelectorAll('[name="inside_diameter_nom"], [name="outside_diameter_nom"]').forEach(function (input) {
      input.removeAttribute('aria-invalid');
      input.classList.remove(INPUT_ERROR_CLASS);
    });
  }

  function showIdOdError(form) {
    var err = ensureErrorEl(form);
    err.hidden = false;
    err.textContent = ERROR_MESSAGE;

    var idInput = form.querySelector('[name="inside_diameter_nom"]');
    var odInput = form.querySelector('[name="outside_diameter_nom"]');

    [idInput, odInput].forEach(function (input) {
      if (!input) return;
      input.setAttribute('aria-invalid', 'true');
      input.classList.add(INPUT_ERROR_CLASS);
    });

    if (idInput && typeof idInput.focus === 'function') {
      try {
        idInput.focus();
      } catch (e) {}
    }
  }

  function validateIdOd(form) {
    var idInput = form.querySelector('[name="inside_diameter_nom"]');
    var odInput = form.querySelector('[name="outside_diameter_nom"]');
    var id = parseDim(idInput && idInput.value);
    var od = parseDim(odInput && odInput.value);

    // Only compare when both nominal values are present
    if (id === null || od === null) {
      clearIdOdError(form);
      return true;
    }

    if (id >= od) {
      showIdOdError(form);
      return false;
    }

    clearIdOdError(form);
    return true;
  }

  function bindForm(form) {
    if (!form || form.dataset.idOdValidationBound === '1') return;
    form.dataset.idOdValidationBound = '1';
    ensureErrorEl(form);

    // Capture phase so invalid submit is blocked before other form listeners (e.g. sticky modal close)
    form.addEventListener(
      'submit',
      function (e) {
        if (!validateIdOd(form)) {
          e.preventDefault();
          e.stopImmediatePropagation();
        }
      },
      true
    );

    form.addEventListener('input', function (e) {
      var name = e.target && e.target.name;
      if (name !== 'inside_diameter_nom' && name !== 'outside_diameter_nom') return;

      var err = getErrorEl(form);
      if (err && !err.hidden) {
        validateIdOd(form);
      }
    });

    form.addEventListener('reset', function () {
      window.setTimeout(function () {
        clearIdOdError(form);
      }, 0);
    });
  }

  function init() {
    document.querySelectorAll('form.product-search-form-inner').forEach(bindForm);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
